/* eslint-disable react/no-array-index-key */
import React from 'react';
import classNames from 'classnames';

import { useRouter } from 'next/router';
import asset from '../../../../helpers/assets';
import Icon from '../../../shared/widget/icon';
import { ParkHighlights } from '../../../../types/shared/parkHighlights';
import styles from './accommodation-feature-pills.module.scss';
import { ItemPrice } from '../../../shared/component/item-price';
import { useUnleash } from '../../../../providers/unleashProvider';
import { AccommodationFeaturesV1 } from './accommodation-features-v1';
import { BaseFeature } from '../../../../types/accommodation-features';
import { AccommodationFeaturesV2 } from './accommodation-features-v2';

type Props = {
  v1AccommodationFeatures: ParkHighlights[];
  v2AccommodationFeatures: BaseFeature[];
  v2AccommodationFeatureHighlights: string[];
  numberOfBedrooms: string | number;
  cabinCapacity: string | number;
  price?: number;
  discountedPrice?: number;
};

export const AccommodationFeaturePills = ({
  v1AccommodationFeatures,
  v2AccommodationFeatures,
  v2AccommodationFeatureHighlights,
  numberOfBedrooms,
  cabinCapacity,
  price,
  discountedPrice,
}: Props) => {
  const { query } = useRouter();
  const { isUnleashVariantActiveCsr } = useUnleash();

  const accommodationFeaturesFromSearchApiOn = isUnleashVariantActiveCsr(
    'search-accommodation-features-endpoint',
    '1',
    query,
  );

  const showPrice = !!price;
  return (
    <div className={styles.accommodationFeaturePills}>
      <div
        className={classNames({
          [styles.mainFeaturesWithPrice]: showPrice,
          [styles.mainFeatures]: showPrice,
        })}
      >
        <ul
          className={classNames({
            [styles.mainFeatures]: !showPrice,
            [styles.mainFeaturesContainerWithPrice]: showPrice,
          })}
        >
          <li className={styles.accommodationFeaturePill}>
            <Icon src={asset('bedroom.svg')} alt="" role="presentation" />
            <div>{numberOfBedrooms} bed</div>
          </li>
          <li className={styles.accommodationFeaturePill}>
            <Icon src={asset('persons.svg')} alt="" role="presentation" />
            <div>Sleeps {cabinCapacity}</div>
          </li>
        </ul>
        {price ? (
          <div className={styles.priceWrapper}>
            <ItemPrice price={price} discountedPrice={discountedPrice} isLeadingPrice />
          </div>
        ) : null}
      </div>
      {accommodationFeaturesFromSearchApiOn ? (
        <AccommodationFeaturesV2
          accommodationFeatures={v2AccommodationFeatures}
          accommodationFeatureHighlights={v2AccommodationFeatureHighlights}
        />
      ) : (
        <AccommodationFeaturesV1 featurePills={v1AccommodationFeatures} />
      )}
    </div>
  );
};
